__turbopack_context__.v({
  "appearing": "prices-block-module-scss-module__QCKR_q__appearing",
  "current": "prices-block-module-scss-module__QCKR_q__current",
  "discounted": "prices-block-module-scss-module__QCKR_q__discounted",
  "discounted__price": "prices-block-module-scss-module__QCKR_q__discounted__price",
  "discounted__text": "prices-block-module-scss-module__QCKR_q__discounted__text",
  "loader": "prices-block-module-scss-module__QCKR_q__loader",
  "otherPrices": "prices-block-module-scss-module__QCKR_q__otherPrices",
  "popover": "prices-block-module-scss-module__QCKR_q__popover",
  "popoverContent": "prices-block-module-scss-module__QCKR_q__popoverContent",
  "regular": "prices-block-module-scss-module__QCKR_q__regular",
  "root": "prices-block-module-scss-module__QCKR_q__root",
  "root__discounted": "prices-block-module-scss-module__QCKR_q__root__discounted",
});
